import { useMsal } from '@azure/msal-react';
import { type FC } from 'react';

export const UserHeader: FC = () => {
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const userName = account?.name || account?.username || 'User';

  const handleSignOut = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: '/',
    });
  };

  return (
    <div className="mb-6 flex items-center justify-between border-b border-gray-200 pb-4">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-indigo-100">
          <span className="font-semibold text-indigo-600">{userName.charAt(0).toUpperCase()}</span>
        </div>
        <div>
          <p className="text-sm font-medium text-gray-900">{userName}</p>
          <p className="text-xs text-gray-500">{account?.username}</p>
        </div>
      </div>
      <button
        onClick={handleSignOut}
        className="rounded px-3 py-1 text-sm text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900"
      >
        Sign out
      </button>
    </div>
  );
};
